import React from "react";

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
}

export default function SecondaryButton({ children, className = "", ...rest }: Props) {
  return (
    <button
      type="button"
      className={`bg-zinc-100 text-zinc-700 font-medium text-sm px-4 py-2 rounded-xl hover:bg-zinc-200 transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
      {...rest}
    >
      {children}
    </button>
  );
}
